import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ToastrService } from 'ngx-toastr';
import { InvoiceCsvQuery, SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { buildGenericInvoicesCsv, withCsvReportTitle } from './invoice-csv-export.utils';

@Component({
  selector: 'app-invoice-csv-export-button',
  standalone: true,
  imports: [FontAwesomeModule],
  template: `
    <button
      type="button"
      class="btn btn-outline-primary rounded-4 px-4 ms-2 shadow-sm"
      [disabled]="disabled || downloading"
      (click)="download()"
      aria-label="Descargar listado de facturación en CSV"
    >
      @if (downloading) {
        <fa-icon [icon]="icons.faCircleNotch" animation="spin" class="me-2"></fa-icon>
        Descargando...
      } @else {
        <fa-icon [icon]="icons.faDownload" class="me-2"></fa-icon>
        Descargar CSV
      }
    </button>
  `,
  styles: ``
})
export class InvoiceCsvExportButtonComponent {
  @Input({ required: true }) filters: Record<string, unknown> = {};
  @Input() query: InvoiceCsvQuery = 'query';
  @Input() fileName = 'facturas';
  @Input() reportTitle = 'Reporte de facturas';
  @Input() rows: Array<Record<string, any>> = [];
  @Input() disabled = false;

  downloading = false;

  constructor(
    private settlementsService: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService
  ) {}

  download(): void {
    if (this.disabled || this.downloading) return;

    this.downloading = true;
    if (this.query === 'query_generic') {
      const csv = buildGenericInvoicesCsv(this.rows, this.reportTitle);
      this.finishDownload(csv);
      return;
    }

    this.settlementsService.downloadInvoicesCsv({ ...this.filters }, this.query)
      .subscribe({
        next: (csv: Blob) => {
          void this.saveApiCsv(csv);
        },
        error: () => {
          this.downloading = false;
          this.toastr.error('No se pudo descargar el reporte.', 'Error');
        }
      });
  }

  private async saveApiCsv(csv: Blob): Promise<void> {
    try {
      const titledCsv = await withCsvReportTitle(csv, this.reportTitle);
      this.finishDownload(titledCsv);
    } catch {
      this.downloading = false;
      this.toastr.error('No se pudo preparar el reporte.', 'Error');
    }
  }

  private finishDownload(csv: Blob): void {
    const date = new Date().toISOString().slice(0, 10);
    this.saveCsv(csv, `${this.fileName}-${date}.csv`);
    this.downloading = false;
    this.toastr.success('Reporte descargado correctamente.', 'Éxito');
  }

  private saveCsv(csv: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(csv);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
